<template>
    <!-- 通用底部  :class="{fixedFooter:fixed}"-->
    <div class="footer">
        <div style="text-align:center;color:#fff;font-size:12px;margin-top:45px;cursor:pointer;">
            <div style="line-height:normal;" @click="toLink('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+policeRecordNumber)"><img src="../assets/images/police.png" class="wh20">&nbsp;&nbsp;&nbsp;{{policeRecord}}</div>
            <div style="line-height:normal;margin-top:10px;">{{copyright}}&nbsp;&nbsp;&nbsp;<span style="cursor:pointer;" @click="toLink('https://beian.miit.gov.cn')">{{icpRecord}}</span></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
           
        };
    },
    computed: {
        copyright(){
            return this.$store.getters.getCopyright;
        },
        icpRecord(){
            return this.$store.getters.getIcpRecord;
        },
        policeRecord(){
            return this.$store.getters.getPoliceRecord;
        },
        policeRecordNumber(){
            return this.$store.getters.getPoliceRecordNumber;
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    watch: {

    },
    methods: {
       toLink(url){
            window.open(url);
        }
    },
    components: {

    },
};
</script>

<style scoped>
/* 通用底部 */
.fixedFooter{position:fixed;bottom:0;left:0;width:100%;}
.footer{ position:absolute;bottom:0;width:100%;height:120px;line-height:120px;background:rgba(26,48,57,1);}
.footer-text{font-size:12px;color:rgba(255,255,255,1);}
</style>



// WEBPACK FOOTER //
// src/components/navFooter.vue